export const ROUTES = {
    MAIN:'/',
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASS: '/forgot-password',
    RESET_PASS: '/reset-password',
    PROFILE: '/profile',
    ERROR_MESSAGE: '/error',
    PROJECT_DETAILS: '/project/:id'
  }